import { catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SucccessResponse } from '../interfaces/response/succcess-response';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  api_url = environment.apiEndpoint;
  constructor(private http: HttpClient) {}

  postRequest(
    api_call: string,
    payload: any,
    notEncrypt: boolean = false
  ): Observable<SucccessResponse> {
    if (notEncrypt) {
      return this.http
        .post<SucccessResponse>(this.api_url + api_call, payload, {
          params: { notEncrypt: notEncrypt },
        })
        .pipe(catchError(this.handleError));
    } else {
      return this.http
        .post<SucccessResponse>(this.api_url + api_call, payload)
        .pipe(catchError(this.handleError));
    }
  }

  getRequest(
    api_call: string,
    params?: HttpParams
  ): Observable<SucccessResponse> {
    // console.log('getRequest');
    // console.log(params);
    if (params) {
      api_call = api_call + '?' + params;
    }
    // console.log('api: '+this.api_url+api_call);
    return this.http
      .get<SucccessResponse>(this.api_url + api_call)
      .pipe(catchError(this.handleError));
  }

  putRequest(api_call: string, payload: any): Observable<SucccessResponse> {
    return this.http
      .put<SucccessResponse>(this.api_url + api_call, payload)
      .pipe(catchError(this.handleError));
  }

  deleteRequest(api_call: string, id: number): Observable<SucccessResponse> {
    return this.http
      .delete<SucccessResponse>(this.api_url + api_call + `/${id}`)
      .pipe(catchError(this.handleError));
  }

  downloadFile(api_call: string, params?: HttpParams, fileName?: string) {
    if (params) {
      api_call = api_call + '?' + params.toString();
    }

    return this.http
      .get(this.api_url + api_call, {
        responseType: 'blob',
        params: { notEncrypt: 'true' }, // make sure to convert boolean to string
      })
      .pipe(tap((blob: Blob) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.target = '_blank';
        if (fileName) {
          link.setAttribute('download', fileName); // use setAttribute instead of direct assignment
        }
        link.click(); // initiate the download
      }));
  }

  /**
   * This function will convert data object into FormData and auto detect the File value and append the File to FormData correctly
   *
   * @param api_call
   * @param data data that contain File object or Array of File objects.
   * @returns
   */
  postRequestWithFiles(api_call: string, data: any): Observable<SucccessResponse> {
    const formData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const dataValue = data[key];

        if (this.dataIsFileOrFiles(dataValue)) {
          if (Array.isArray(dataValue)) {
            // laravel specific arrays
            for (const eachItem of dataValue) {
              formData.append(`${key}[]`, eachItem, eachItem.name);
            }
          } else {
            formData.append(key, dataValue, dataValue.name);
          }
        } else if (Array.isArray(dataValue)) {
          // laravel specific arrays
          for (const eachItem of dataValue) {
            formData.append(`${key}[]`, eachItem);
          }
        } else {
          formData.append(key, dataValue);
        }
      }
    }

    return this.http.post(this.api_url + api_call, formData, {
      params: { notEncrypt: true },
    });
  }

  dataIsFileOrFiles(data: any): data is File | File[] {
    if (Array.isArray(data)) {
      return data.every((d) => d instanceof File);
    } else {
      return data instanceof File;
    }
  }

  getAuthorizationToken(): any {
    return localStorage.getItem('access_token');
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(`unknown error: ${error}`);
      console.error(
        `Backend returned code ${error.status}, body was: `,
        error.error
      );
    }
    // Return an observable with a user-facing error message.
    return throwError(() => error.error);
  }
}
